import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SearchControl = _resolveComponent("SearchControl")!

  return (_openBlock(), _createBlock(_component_SearchControl, _mergeProps(_ctx.$attrs, {
    search: _ctx.finder.search.bind(_ctx.finder),
    value: _ctx.value,
    onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('input', $event)))
  }), null, 16, ["search", "value"]))
}